import config from 'config';
import axios from 'axios';

const ROOT = config.API_BASE_URL;

class DashboardService {

  static getAvailableDashboards() {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}dashboards`).then((response) => {
        resolve({ data: response.data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static getReportOrDashboardDataByToken(token, pageSize = null, page = null, filters = {}, sorts = []) {
    return new Promise((resolve, reject) => {
      const ascSorts = sorts.length > 0 ? `&asc=${sorts.filter(sortValue => !sortValue.desc).map(sortValue => sortValue.id).join(',')}` : '';
      const descSorts = sorts.length > 0 ? `&desc=${sorts.filter(sortValue => sortValue.desc).map(sortValue => sortValue.id).join(',')}` : '';
      const filterQuery = Object.keys(filters).length > 0 ? `&arguments=${encodeURIComponent(JSON.stringify(filters))}` : '';
      const pageValue = pageSize != null && page != null ? `pageSize=${pageSize}&page=${page}` : 'nop=';
      axios.get(`${ROOT}reports/templates/${token}/execute?${pageValue}${ascSorts}${descSorts}${filterQuery}`).then((response) => {
        resolve({ token: token, data: response.data, reportResult: JSON.parse(response.data.reportResult) });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static getAlertsByTime(timeConstraint, filterGroupId, filterGroupingId, categoryFilterIds) {
    return new Promise((resolve, reject) => {
      const query = `timeConstraint=${timeConstraint}&categoryFilterIds=${categoryFilterIds.join(',')}&filterGroupId=${filterGroupId == null ? -1 : filterGroupId}&filterGroupingId=${filterGroupingId == null ? -1 : filterGroupingId}`;
      axios.get(`${ROOT}dashboards/legacy/alerts?${query}`).then((data) => {
        resolve({ alerts: data.data, page: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static getNeedsAttentionDashboardData() {
        return new Promise((resolve, reject) => {
      axios.get(`${ROOT}dashboards/legacy/needs-attention-dashboard-data`).then((response) => {
        resolve({ data: response.data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

}
export default DashboardService;
